/* TODO: need to remove library */
import Ractive from '../../../webroot/media/scripts/modules/ractive'
import fade from 'ractive-transitions-fade'

document.addEventListener('DOMContentLoaded', () => {
  const spiral = window.spiral
  const pl = window.pl

  const Modal = window.Modal = Ractive.extend({
    el: document.body,
    append: true,
    template: '#tpl-modal',
    transitions: { fade },
    onrender () {
      const t = this

      t.on('close', () => {
        if (t.get('confirmLeavingPageFlag')) { pl.confirmLeavingPageFlag = true }

        t.teardown()
        if (t.get('refreshOnClose')) {
          location.reload()
        }
      })
      if (t.get('action')) {
        t.on('submit', () => {
          t.teardown()
          spiral.ajax({
            url: t.get('action'),
            processAnswer (r) {
              if (r.response && r.response.status === 200) { location.href = r.response.action.redirect }
            },
          })
        })
      }
    },
  })

  $(document).on('click', '.js-modal', function (e) {
    e.preventDefault()
    const data = {}

    $.extend(data, $(this).data())
    if (window.modalData) {
      $.extend(data, window.modalData)
    }

    Modal({ data })
  })

  window.cbRefresh = result => {
    if (result.response.status === 201 || result.response.status === 200) {
      location.reload()
    }
  }
}, true)
